(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/adobe-target-payload-handler/assets/javascripts/send-view-payload.js') >= 0) return;  svs.modules.push('/components/components/adobe-target-payload-handler/assets/javascripts/send-view-payload.js'); "use strict";

var _svs$components$adobe = svs.components.adobeTargetPayloadHandler.helpers,
    checkIfDataAttributesExists = _svs$components$adobe.checkIfDataAttributesExists,
    getDataAttributeValue = _svs$components$adobe.getDataAttributeValue,
    getAllDataAttributes = _svs$components$adobe.getAllDataAttributes;
var logger = svs.core.log.getLogger('components:adobe-target-payload-handler'); 

var CRM_ANALYTICS_PAYLOAD_PE = 'crmAnalyticsPayloadPe';
var CRM_ANALYTICS_PAYLOAD_TNTA = 'crmAnalyticsPayloadTnta'; 

var CRM_MBOX = 'crmMbox';
var CRM_EVENT_TOKEN = 'crmEventToken';
var CRM_STATE = 'crmState';

var errorHandlerTarget = function errorHandlerTarget(error) {
  logger.warn("call to target notification for DISPLAY went wrong ".concat(error.toString()), error);
};

var sendView = function sendView(element) {
  var targetDisplay = svs.components.adobeTargetNotification.display;
  var sendAnalytics = svs.components.analytics.sendTargetPayload;

  if (checkIfDataAttributesExists(element, [CRM_ANALYTICS_PAYLOAD_PE, CRM_ANALYTICS_PAYLOAD_TNTA])) {
    var pe = getDataAttributeValue(element, CRM_ANALYTICS_PAYLOAD_PE);
    var tnta = getDataAttributeValue(element, CRM_ANALYTICS_PAYLOAD_TNTA);
    sendAnalytics({
      pe: pe,
      tnta: tnta
    });
  } else if (checkIfDataAttributesExists(element, [CRM_MBOX, CRM_EVENT_TOKEN, CRM_STATE])) {
    var mbox = getDataAttributeValue(element, CRM_MBOX);
    var token = getDataAttributeValue(element, CRM_EVENT_TOKEN);
    var state = getDataAttributeValue(element, CRM_STATE);
    targetDisplay({
      mboxName: mbox,
      tokens: [token],
      state: state,
      errorCallback: errorHandlerTarget
    });
  } else {
    logger.warn("Try to send target payload data but payload is missing! ".concat(getAllDataAttributes(element).toString()));
  }
};

svs.components.adobeTargetPayloadHandler.sendView = sendView;
 })(window);